import type {GpsState} from '../gpsController';

/** Optional local model hint, never permission to open actions or listen. */
export function listeningRegion(gps:{allowed:boolean;enabled:boolean;state:GpsState},now=Date.now()){
 const p=gps.state.position;
 if(!gps.allowed||!gps.enabled||gps.state.permission!=='granted'||gps.state.status!=='tracking'||!p||
  !Number.isFinite(p.timestamp)||now-p.timestamp>45000||p.timestamp>now+10000||
  !Number.isFinite(p.coords.accuracy)||p.coords.accuracy<0||p.coords.accuracy>100||
  !Number.isFinite(p.coords.latitude)||Math.abs(p.coords.latitude)>90||
  !Number.isFinite(p.coords.longitude)||Math.abs(p.coords.longitude)>180)return undefined;
 return {latitude:p.coords.latitude,longitude:p.coords.longitude};
}
